import {
  Box,
  CircularProgress,
  Typography,
  Fade,
} from '@mui/material';
import React from 'react';

function LoadingSpinner({ 
  message = '로딩 중...',
  size = 40,
  color = 'primary',
  fullScreen = false,
  overlay = false,
}) {
  const content = (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={2}
      sx={{
        ...(fullScreen && {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: overlay ? 'rgba(255, 255, 255, 0.8)' : 'background.default',
          zIndex: 9999,
        }),
        ...(overlay && !fullScreen && {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: 'rgba(255, 255, 255, 0.8)',
          zIndex: 1,
        }),
        minHeight: fullScreen ? 'auto' : '200px',
      }}
    >
      <CircularProgress size={size} color={color} />
      {message && (
        <Typography variant="body2" color="text.secondary" textAlign="center">
          {message}
        </Typography>
      )}
    </Box>
  );

  return (
    <Fade in timeout={300}>
      {content}
    </Fade>
  );
}

export default LoadingSpinner;